const confirmation = {
    deleteDocument: 'Are you sure you want to delete this document?',
    unsavedChangesTitle: 'Unsaved input',
    unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
    discardChangesTitle: 'Discard changes',
    discardChangesConfirm: 'Discard',
  };

export default confirmation;
